import {Component, Input, OnInit, OnDestroy, ElementRef, Output, EventEmitter} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

// Services
import { TranslationService } from '../../services/translation.service';

import * as fromCore from '../../../core/reducers';
import {Store} from '@ngrx/store';

@Component({
  selector: 'language-horizontal',
  templateUrl: './language-horizontal.component.html',
  styleUrls: ['./language-horizontal.component.scss']
})
export class LanguageHorizontalComponent implements OnInit, OnDestroy {

  // Inputs variables
  @Input() shortVersion: boolean = false;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Current lang
  public currentLang: string;
  public langsAvailable: Array<any>;
  public isMultiLanguage: boolean = false;

  public currentLanguage$: Observable<string> = this.coreStore.select(state => state.core.ui.currentLanguage);

  // Subscription
  private currentLanguageSubscription: Subscription;

  // Public variables
  public items: any[];

  constructor(
    private _eref: ElementRef,
    private translationService: TranslationService,
    private coreStore: Store<fromCore.State>,
  ) { }

  // On component init
  ngOnInit() {
    this.currentLang = this.translationService.currentLangShortName;
    this.langsAvailable = this.translationService.langsAvailable;
    this.isMultiLanguage = this.langsAvailable.length > 1;

    this.currentLanguageSubscription = this.currentLanguage$.subscribe((lang) => {
      if (lang && this.translationService.currentLangShortName !== this.currentLang) {
        this.useLanguage(lang);
      }
    });
  }

  // On component destroy
  ngOnDestroy() {
    this.currentLanguageSubscription.unsubscribe();
  }

  // Change language
  useLanguage(lang: string) {
    this.translationService.use(lang);
    this.currentLang = this.translationService.currentLangShortName;
    this.onItemSelect.emit(lang);
  }

  // Change language
  emitItemSelect(lang: any) {
    this.currentLang = lang.key;
    this.onItemSelect.emit(lang.code);
  }
}



// WEBPACK FOOTER //
// ./src/app/translation/components/language-horizontal/language-horizontal.component.ts